(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { getProjectId } from "jcb-token-kit";
// 是否隐藏项目列表图标
export var isShowProjectList = function isShowProjectList(userInfo) {
  if (getProjectId() === "1") {
    // 如果是西城
    if (userInfo.roleStr === "resorg_normal" || userInfo.roleStr === "busorg_normal" || userInfo.roleStr === "leader_normal") {
      return false;
    }
    return true;
  }
  return true;
};

// 是否隐藏客户端下载图标
export var isShowDownload = function isShowDownload(userInfo) {
  if (getProjectId() === "1") {
    // 如果是西城
    if (userInfo.roleStr === "resorg_normal" || userInfo.roleStr === "busorg_normal" || userInfo.roleStr === "leader_normal") {
      return false;
    }
    return true;
  }
  return true;
};
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(isShowProjectList, "isShowProjectList", "src/utils/custom-show.js");
  reactHotLoader.register(isShowDownload, "isShowDownload", "src/utils/custom-show.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();